export default __webpack_public_path__ + "static/media/view-reports.0958f3e0.png";